import { render, staticRenderFns } from "./BranchAdminKabupaten.vue?vue&type=template&id=7ecbeab0&"
import script from "./BranchAdminKabupaten.vue?vue&type=script&lang=js&"
export * from "./BranchAdminKabupaten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports